// Coverage Modal JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Get asset base URL from the existing country matcher config or create one
  const assetBaseUrl = window.countryMatcherConfig?.assetBaseUrl || 
    (window.theme?.assets_url ? window.theme.assets_url + '/' : '');
  
  // Debug logging
  console.log('Coverage Modal - Asset Base URL:', assetBaseUrl);
  // Function to get country code from country name (shared with country-flags-modal)
  function getCountryCode(countryName) {
    if (!countryName) return null;
    
    const cleanCountryName = countryName.trim().toLowerCase();
    
    // Direct mapping for common variations and exact matches
    const directMappings = {
      'usa': 'us',
      'united states': 'us',
      'united states of america': 'us',
      'uk': 'gb',
      'united kingdom': 'gb',
      'england': 'gb-eng',
      'scotland': 'gb-sct',
      'wales': 'gb-wls',
      'northern ireland': 'gb-nir',
      'south korea': 'kr',
      'north korea': 'kp',
      'russia': 'ru',
      'czech republic': 'cz',
      'czechia': 'cz',
      'czechia (czech republic)': 'cz',
      'dr congo': 'cd',
      'democratic republic of the congo': 'cd',
      'republic of the congo': 'cg',
      'congo': 'cg',
      'congo (congo-brazzaville)': 'cg',
      'ivory coast': 'ci',
      'côte d\'ivoire (ivory coast)': 'ci',
      'côte d\'ivoire': 'ci',
      'cape verde': 'cv',
      'cabo verde': 'cv',
      'costa rica': 'cr',
      'dominican republic': 'do',
      'el salvador': 'sv',
      'equatorial guinea': 'gq',
      'guinea-bissau': 'gw',
      'new zealand': 'nz',
      'papua new guinea': 'pg',
      'puerto rico': 'pr',
      'saudi arabia': 'sa',
      'sierra leone': 'sl',
      'solomon islands': 'sb',
      'south africa': 'za',
      'south sudan': 'ss',
      'sri lanka': 'lk',
      'trinidad and tobago': 'tt',
      'united arab emirates': 'ae',
      'vatican city': 'va',
      'vatican city (holy see)': 'va',
      'northern cyprus': 'cy',
      'southern cyprus': 'cy',
      'guadeloupe': 'gp',
      'hong kong': 'hk',
      'macao': 'mo',
      'martinique': 'mq',
      'mayotte': 'yt',
      'north macedonia': 'mk',
      'sao tome and principe': 'st',
      'turkiye': 'tr',
      'afghanistan': 'af',
      'albania': 'al',
      'algeria': 'dz',
      'andorra': 'ad',
      'angola': 'ao',
      'argentina': 'ar',
      'armenia': 'am',
      'australia': 'au',
      'austria': 'at',
      'azerbaijan': 'az',
      'bahamas': 'bs',
      'bahrain': 'bh',
      'bangladesh': 'bd',
      'barbados': 'bb',
      'belarus': 'by',
      'belgium': 'be',
      'belize': 'bz',
      'benin': 'bj',
      'bhutan': 'bt',
      'bolivia': 'bo',
      'bosnia and herzegovina': 'ba',
      'botswana': 'bw',
      'brazil': 'br',
      'brunei': 'bn',
      'bulgaria': 'bg',
      'burkina faso': 'bf',
      'burundi': 'bi',
      'cambodia': 'kh',
      'cameroon': 'cm',
      'canada': 'ca',
      'central african republic': 'cf',
      'chad': 'td',
      'chile': 'cl',
      'china': 'cn',
      'colombia': 'co',
      'comoros': 'km',
      'croatia': 'hr',
      'cuba': 'cu',
      'cyprus': 'cy',
      'denmark': 'dk',
      'djibouti': 'dj',
      'dominica': 'dm',
      'ecuador': 'ec',
      'egypt': 'eg',
      'eritrea': 'er',
      'estonia': 'ee',
      'eswatini (swaziland)': 'sz',
      'swaziland': 'sz',
      'ethiopia': 'et',
      'fiji': 'fj',
      'finland': 'fi',
      'france': 'fr',
      'gabon': 'ga',
      'gambia': 'gm',
      'georgia': 'ge',
      'germany': 'de',
      'ghana': 'gh',
      'greece': 'gr',
      'grenada': 'gd',
      'guatemala': 'gt',
      'guinea': 'gn',
      'guyana': 'gy',
      'haiti': 'ht',
      'honduras': 'hn',
      'hungary': 'hu',
      'iceland': 'is',
      'india': 'in',
      'indonesia': 'id',
      'iran': 'ir',
      'iraq': 'iq',
      'ireland': 'ie',
      'israel': 'il',
      'italy': 'it',
      'jamaica': 'jm',
      'japan': 'jp',
      'jordan': 'jo',
      'kazakhstan': 'kz',
      'kenya': 'ke',
      'kiribati': 'ki',
      'kosovo': 'xk',
      'kuwait': 'kw',
      'kyrgyzstan': 'kg',
      'laos': 'la',
      'latvia': 'lv',
      'lebanon': 'lb',
      'lesotho': 'ls',
      'liberia': 'lr',
      'libya': 'ly',
      'liechtenstein': 'li',
      'lithuania': 'lt',
      'luxembourg': 'lu',
      'macedonia': 'mk',
      'madagascar': 'mg',
      'malawi': 'mw',
      'malaysia': 'my',
      'maldives': 'mv',
      'mali': 'ml',
      'malta': 'mt',
      'marshall islands': 'mh',
      'mauritania': 'mr',
      'mauritius': 'mu',
      'mexico': 'mx',
      'micronesia': 'fm',
      'moldova': 'md',
      'monaco': 'mc',
      'mongolia': 'mn',
      'montenegro': 'me',
      'morocco': 'ma',
      'mozambique': 'mz',
      'myanmar': 'mm',
      'namibia': 'na',
      'nauru': 'nr',
      'nepal': 'np',
      'netherlands': 'nl',
      'nicaragua': 'ni',
      'niger': 'ne',
      'nigeria': 'ng',
      'norway': 'no',
      'oman': 'om',
      'pakistan': 'pk',
      'palau': 'pw',
      'palestine': 'ps',
      'panama': 'pa',
      'paraguay': 'py',
      'peru': 'pe',
      'philippines': 'ph',
      'poland': 'pl',
      'portugal': 'pt',
      'qatar': 'qa',
      'romania': 'ro',
      'rwanda': 'rw',
      'saint kitts and nevis': 'kn',
      'saint lucia': 'lc',
      'saint vincent and the grenadines': 'vc',
      'samoa': 'ws',
      'san marino': 'sm',
      'são tomé and príncipe': 'st',
      'senegal': 'sn',
      'serbia': 'rs',
      'seychelles': 'sc',
      'singapore': 'sg',
      'slovakia': 'sk',
      'slovenia': 'si',
      'somalia': 'so',
      'spain': 'es',
      'sudan': 'sd',
      'suriname': 'sr',
      'sweden': 'se',
      'switzerland': 'ch',
      'syria': 'sy',
      'taiwan': 'tw',
      'tajikistan': 'tj',
      'tanzania': 'tz',
      'thailand': 'th',
      'timor-leste': 'tl',
      'togo': 'tg',
      'tonga': 'to',
      'tunisia': 'tn',
      'turkey': 'tr',
      'turkmenistan': 'tm',
      'tuvalu': 'tv',
      'uganda': 'ug',
      'ukraine': 'ua',
      'uruguay': 'uy',
      'uzbekistan': 'uz',
      'vanuatu': 'vu',
      'venezuela': 've',
      'vietnam': 'vn',
      'yemen': 'ye',
      'zambia': 'zm',
      'zimbabwe': 'zw'
    };
    
    // Check direct mappings first
    return directMappings[cleanCountryName] || null;
  }

  // Function to populate coverage preview
  function populateCoveragePreview(version = 'desktop') {
    let coveragePreview, viewAllBtn;
    
    if (version === 'mobile') {
      coveragePreview = document.querySelector('#coverage-preview-mobile-{{ product.id }}');
      viewAllBtn = document.querySelector('.accordion-container .view-all-countries-btn');
    } else {
      coveragePreview = document.querySelector('.coverage-countries-preview:not([id*="mobile"])');
      viewAllBtn = document.querySelector('.product-tabs-container > .product-tab-content .view-all-countries-btn');
    }
    
    if (!coveragePreview) return;
    if (!viewAllBtn) return;

    const countriesData = viewAllBtn.getAttribute('data-countries');
    if (!countriesData || !countriesData.trim()) return;

    const countries = countriesData.split('|').map(country => country.trim()).filter(country => country);
    const previewCountries = countries.slice(0, 10); // Show max 10 countries

    coveragePreview.innerHTML = '';

    previewCountries.forEach(country => {
      const countryItem = document.createElement('div');
      countryItem.className = 'coverage-preview-item';
      
      // Get country code for flag
      const countryCode = getCountryCode(country);
      
      if (countryCode) {
        const flagImg = document.createElement('img');
        flagImg.src = `${assetBaseUrl}${countryCode}.svg`;
        flagImg.alt = `${country} flag`;
        flagImg.className = 'preview-country-flag';
        flagImg.loading = 'lazy';
        flagImg.onerror = function() {
          console.warn(`Failed to load flag for ${country} (${countryCode}):`, this.src);
          this.style.display = 'none';
        };
        flagImg.onload = function() {
          console.log(`Successfully loaded flag for ${country} (${countryCode}):`, this.src);
        };
        
        const countryText = document.createElement('span');
        countryText.className = 'preview-country-name';
        countryText.textContent = country;
        
        countryItem.appendChild(flagImg);
        countryItem.appendChild(countryText);
      } else {
        countryItem.textContent = country;
        countryItem.className += ' no-flag';
      }
      
      coveragePreview.appendChild(countryItem);
    });
  }

  // Store countries data globally for search functionality
  window.modalCountriesData = window.modalCountriesData || {};

  // Global function to open coverage modal
  window.openCoverageModal = function(productId) {
    const modal = document.getElementById('coverage-modal-' + productId);
    const button = document.querySelector(`[onclick="openCoverageModal('${productId}')"]`);
    
    if (!modal || !button) return;
    
    const countriesData = button.getAttribute('data-countries');
    const productTitle = button.getAttribute('data-product-title');
    const countriesList = document.getElementById('coverage-countries-' + productId);
    const countText = document.getElementById('coverage-count-text-' + productId);
    const searchInput = document.getElementById('country-search-' + productId);
    const noResults = document.getElementById('no-results-' + productId);
    
    // Clear search input and reset
    if (searchInput) searchInput.value = '';
    if (noResults) noResults.style.display = 'none';
    
    // Clear existing content
    countriesList.innerHTML = '';
    
    if (countriesData && countriesData.trim()) {
      const countries = countriesData.split('|').map(country => country.trim()).filter(country => country);
      
      // Store countries data for search functionality
      window.modalCountriesData[productId] = countries;
      
      if (countries.length > 0) {
        // Update count text
        const countLabel = countries.length === 1 ? 'Country' : 'Countries';
        if (countText) {
          countText.innerHTML = `Country coverage: <strong>${countries.length} ${countLabel}</strong>`;
        }
        
        countries.forEach(country => {
          const countryItem = document.createElement('div');
          countryItem.className = 'coverage-country-item';
          
          // Get country code for flag
          const countryCode = getCountryCode(country);
          
          if (countryCode) {
            const flagImg = document.createElement('img');
            flagImg.src = `${assetBaseUrl}${countryCode}.svg`;
            flagImg.alt = `${country} flag`;
            flagImg.className = 'country-flag';
            flagImg.loading = 'lazy';
            flagImg.onerror = function() {
              console.warn(`Failed to load flag for ${country} (${countryCode}):`, this.src);
              this.style.display = 'none';
            };
            flagImg.onload = function() {
              console.log(`Successfully loaded flag for ${country} (${countryCode}):`, this.src);
            };
            
            const countryText = document.createElement('span');
            countryText.className = 'country-name';
            countryText.textContent = country;
            
            countryItem.appendChild(flagImg);
            countryItem.appendChild(countryText);
          } else {
            countryItem.textContent = country;
          }
          
          countriesList.appendChild(countryItem);
        });
      } else {
        if (countText) {
          countText.innerHTML = 'Country coverage: <strong>0 Countries</strong>';
        }
        countriesList.innerHTML = '<div class="coverage-country-item">No specific countries listed</div>';
      }
    } else {
      if (countText) {
        countText.innerHTML = 'Country coverage: <strong>0 Countries</strong>';
      }
      countriesList.innerHTML = '<div class="coverage-country-item">Coverage information not available</div>';
    }
    
    modal.style.display = 'flex';
    
    // Prevent body scrolling
    const body = document.body;
    const html = document.documentElement;
    const scrollY = window.scrollY;
    
    // Store current scroll position
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    
    // Also prevent html scrolling
    html.style.overflow = 'hidden';
    
    // Store scroll position for restoration
    modal.dataset.scrollY = scrollY;
    
    // Focus on search input for better UX
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  };

  // Global function to close coverage modal
  window.closeCoverageModal = function(productId) {
    const modal = document.getElementById('coverage-modal-' + productId);
    if (modal) {
      modal.style.display = 'none';
      
      // Restore body scrolling
      const body = document.body;
      const html = document.documentElement;
      const scrollY = modal.dataset.scrollY || 0;
      
      // Remove fixed positioning
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflow = '';
      
      // Restore html overflow
      html.style.overflow = '';
      
      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY) || 0);
      
      // Clean up stored scroll position
      delete modal.dataset.scrollY;
    }
  };

  // Filter countries based on search input
  window.filterCountries = function(productId) {
    const searchInput = document.getElementById('country-search-' + productId);
    const countriesList = document.getElementById('coverage-countries-' + productId);
    const noResults = document.getElementById('no-results-' + productId);
    const countText = document.getElementById('coverage-count-text-' + productId);
    
    if (!searchInput || !countriesList || !window.modalCountriesData[productId]) return;
    
    const searchTerm = searchInput.value.toLowerCase().trim();
    const allCountries = window.modalCountriesData[productId];
    
    // Filter countries based on search term
    const filteredCountries = allCountries.filter(country => 
      country.toLowerCase().includes(searchTerm)
    );
    
    // Clear current countries list
    countriesList.innerHTML = '';
    
    if (filteredCountries.length > 0) {
      noResults.style.display = 'none';
      countriesList.style.display = 'grid';
      
      filteredCountries.forEach(country => {
        const countryItem = document.createElement('div');
        countryItem.className = 'coverage-country-item';
        
        // Get country code for flag
        const countryCode = getCountryCode(country);
        
        if (countryCode) {
          const flagImg = document.createElement('img');
          flagImg.src = `${assetBaseUrl}${countryCode}.svg`;
          flagImg.alt = `${country} flag`;
          flagImg.className = 'country-flag';
          flagImg.loading = 'lazy';
          flagImg.onerror = function() {
            console.warn(`Failed to load flag for ${country} (${countryCode}):`, this.src);
            this.style.display = 'none';
          };
          flagImg.onload = function() {
            console.log(`Successfully loaded flag for ${country} (${countryCode}):`, this.src);
          };
          
          const countryText = document.createElement('span');
          countryText.className = 'country-name';
          countryText.textContent = country;
          
          countryItem.appendChild(flagImg);
          countryItem.appendChild(countryText);
        } else {
          countryItem.textContent = country;
        }
        
        countriesList.appendChild(countryItem);
      });
      
      // Update count text
      const countLabel = filteredCountries.length === 1 ? 'Country' : 'Countries';
      if (searchTerm) {
        countText.textContent = `Showing ${filteredCountries.length} of ${allCountries.length} ${countLabel}`;
      } else {
        countText.innerHTML = `Country coverage: <strong>${filteredCountries.length} ${countLabel}</strong>`;
      }
    } else {
      noResults.style.display = 'block';
      countriesList.style.display = 'none';
      countText.textContent = `Showing 0 of ${allCountries.length} Countries`;
    }
  };

  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('.coverage-modal[style*="flex"]');
      if (openModal) {
        const productId = openModal.id.replace('coverage-modal-', '');
        window.closeCoverageModal(productId);
      }
    }
  });

  // Initialize coverage preview on page load if coverage tab is active
  setTimeout(populateCoveragePreview, 200);
});